export const LIMIT_MAX = 99999
export const LIMIT_20 = 20
export const LIMIT_10 = 10
export const LIMIT_5 = 5
export const ALPHANUMERIC_WITH_DASH_DOT = "^[\\w \\-.]*$"
export const ALPHA_DIACRITIC_REGEXP = "^[\\w \\-().,&'#/~; \\p{L}+|\\p{M}+]*$"
export const CITY_REGEXP = "^[\\w \\-().,&'#/~; \\p{L}+|\\p{M}+]*$"
export const ADDRESS_REGEXP = "^[\\w \\-\\(\\).,'#&\\/~;: \\p{L}+\\|\\p{M}+]*$"
export const NAME_REGEXP = "^[\\w \\-\\(\\).,&'#\\/~;! \\p{L}+\\|\\p{M}+]*$"
export const USER_NAME_REGEXP = "^[\\w\\-_!#$% &'*+\\/`=?@.,\\p{L}+\\|\\p{M}+]*$"
export const EMAIL_REGEXP = "^[a-zA-Z0-9_!#$%&'*+\\/`=?\\{\\|\\}~^.\\-]+@[a-zA-Z0-9.\\-]+.[a-zA-Z]{2,63}$"
export const PASSWORD_REGEX = '^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[!-/:-@[-`{-~]).{12,255}$'
export const NUMBERS_ONLY_REGEX = '^(?=.*?[0-9]).{6,}$'
export const CONTAINS_SYMBOL_REGEX = '^(?=.*?[!-/:-@[-`{-~])'
export const CONTAINS_NUMBER_REGEX = '^(.*[0-9].*)'
export const CONTAINS_UPPERCASE_REGEX = '^(.*[A-Z].*)'
export const CONTAINS_LOWERCASE_REGEX = '^(.*[a-z].*)'
export const MIN_PASSWORD_CHARS = 12
export const MAX_PASSWORD_CHARS = 255
export const MIN_OTP_CHARS = 6
export const IMAUTH_API_V1 = 'app/imauth/api/v1'
export const ACCOUNT_UI_API_VI = 'app/account/ui-api/v1'
export const UPDATE_PASSWORD = 'UPDATE_PASSWORD'
export const ACCOUNTS_LOCALE_COOKIE_NAME = 'lang'
export const LOCALES = 'locales'
export const ACCOUNTS_LOGIN_ACTION_TOKEN = 'accounts.login.action.token'
export const NEW_LOOK_ANNOUNCEMENT_DISMISSED = 'new-look-announcement-dismissed'
export const AGREEMENT_URL = 'http://www.digicert.com/master-services-agreement'
export const POLICY_URL = 'https://www.digicert.com/digicert-privacy-policy/'
export const CHARSET_1 = "abcdefghijklmnopqrstuvwxyz"
export const CHARSET_2 = "ABCDEFGHIJKLMNOPQRSTUVWXYZ"

